import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import './css/tailwind.css';
import 'react-circular-progressbar/dist/styles.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

Sentry.init({
  dsn:
    'https://3cf86955b0794aaf8f970790128e5a57@o440131.ingest.sentry.io/5480356',
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
